<template>
  <div class="media">
    <div class="media__actions">
      <div class="media__actions__left">
        <button v-if="!isModal" type="button" class="btn-regular primary btn-upload" @click.stop="openUpload()">Upload file</button>
        <adx-dropdown v-if="!isModal" class="filter-dropdown" @selected="selectOrientation" :list="listOrientation" labelButton="All orientation" />
        <adx-dropdown class="sorting-dropdown" @selected="selectSortBy" :list="listSort" labelButton="Last added" />
      </div>
      <div class="media__actions__right">
        <div class="media__actions__right__sorting">
          <div class="sorting-text">Sort by :</div>
          <adx-dropdown-sort
            class="sorting-dropdown"
            :value.sync="sortBy"
            :type="true"
            :label="'Select sort'"
            :options="listSort" />
        </div>
        <div class="media__actions__right__view">
          <span :class="{active: displayGrid}" @click.stop="changeView('grid')"><i class="icon-grid"></i></span>
          <span :class="{active: !displayGrid}" @click.stop="changeView('list')"><i class="icon-left-align"></i></span>
        </div>
      </div>
    </div>
    <div :class="['media__search', listSelectedItem.length > 0 ? 'end' : '']">
      <div :class="['media__search__box', listSelectedItem.length > 0 ? 'visible' : '']" @click.stop="focusSearch()">
        <span class="icon"><i class="icon-search"></i></span>
        <input ref="search" type="text" name="search" v-model="searchingText" class="search-input subhead" placeholder="Search library . .">
      </div>
      <div v-if="listSelectedItem.length == 0" class="media__search__view">
        <span :class="['icon-display', displayGrid ? 'active' : '']" @click.stop="changeView('grid')"><i class="icon-grid"></i></span>
        <span :class="['icon-display', !displayGrid ? 'active' : '']" @click.stop="changeView('list')"><i class="icon-left-align"></i></span>
      </div>
      <div v-if="!isModal && listSelectedItem.length > 0" class="media__search__action">
        <button type="button" class="secondary btn-small" @click.stop="unselectAllItem()">Cancel</button>
        <button type="button" class="secondary btn-small" @click.stop="selectAllItem()">Select All</button>
        <button type="button" class="primary btn-small" @click.stop="openModalDelete()">Delete</button>
      </div>
    </div>
    <template v-if="filteredItems.length > 0 && !isLoading">
      <div v-if="displayGrid" :class="['media__content_view', 'grid-view', isModal ? 'view-modal' : '']">
        <div v-for="(item, index) in filteredItems" :key="item.id" class="media__content_view__thumbnail" @click.stop="isModal ? assign(item) : preview(item, index)">
          <div :class="['img-thumb', listSelectedItem.includes(item.id) ? 'selected' : '']" :style="{backgroundImage: `url('${item.thumbnail}')`}">
            <span v-if="!isModal" class="selection-checkbox" @click.stop="selectItem(item.id)">
              <i class="icon-check"></i>
            </span>
          </div>
          <span class="filename small-font">{{item.title}}</span>
        </div>
      </div>
      <div v-else class="media__content_view list-view">
        <table class="table-list-media">
          <thead>
            <th v-if="!isModal" :class="['action-checkbox', 'regular-font', selectAll ? 'selected' : '']">
              <span class="selection-checkbox" @click.stop="toggleCheckAllItem()"><i class="icon-check"></i></span>
            </th>
            <th class="regular-font">Files</th>
            <th class="uploaded-column regular-font">Uploaded To</th>
            <th class="date-column regular-font">Date</th>
            <th class="size-column regular-font">File Size</th>
          </thead>
          <tbody>
            <tr v-for="(item, index) in filteredItems" :key="item.id" class="row-content" @click.stop="isModal ? assign(item) : preview(item, index)">
              <td v-if="!isModal" :class="['action-checkbox', listSelectedItem.includes(item.id) ? 'selected' : '']">
                <span class="selection-checkbox" @click.stop="selectItem(item.id)"><i class="icon-check"></i></span>
              </td>
              <td>
                <div class="files">
                  <div class="file-thumb" :style="{backgroundImage: `url('${item.thumbnail}')`}">
                  </div>
                  <div class="file-info">
                    <span class="name regular-font">{{item.title}}</span>
                    <span class="detail small-font">{{item.orientation_display}}</span>
                  </div>
                </div>
              </td>
              <td><span class="uploaded-text">{{listCollection(item.uploaded_to)}}</span></td>
              <td><span class="date-text">{{formatDate(item.created)}}</span></td>
              <td><span class="size-text">{{fileSizeConverter(item.file_size)}}</span></td>
            </tr>
          </tbody>
        </table>
        <table class="table-list-media-mobile">
          <thead>
            <th v-if="!isModal" :class="['action-checkbox', 'regular-font', selectAll ? 'selected' : '']">
              <span class="selection-checkbox" @click.stop="toggleCheckAllItem()"><i class="icon-check"></i></span>
            </th>
            <th>Files</th>
          </thead>
          <tbody>
            <tr v-for="(item, index) in filteredItems" :key="item.id" class="row-content" @click.stop="isModal ? '' : preview(item, index)">
              <td v-if="!isModal" :class="['action-checkbox', listSelectedItem.includes(item.id) ? 'selected' : '']">
                <span class="selection-checkbox" @click.stop="selectItem(item.id)"><i class="icon-check"></i></span>
              </td>
              <td>
                <div class="files">
                  <div class="file-thumb" :style="{backgroundImage: `url('${item.thumbnail}')`}">
                  </div>
                  <div class="file-info">
                    <span class="name regular-font">{{item.title}}</span>
                    <span class="detail small-font">{{item.type}} . {{item.orientation_display}}</span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template v-else-if="filteredItems.length == 0 && !isLoading">
      <div class="empty-content">
        <img src="/img/notfound/notfound.png" alt="">
      </div>
    </template>
    <adx-modal
      v-if="modalUpload"
      title="Upload File"
      type="large"
      @modal-close="closeUploadAndGetData"
    >
      <div slot="content" class="upload">
        <div class="upload__content">
          <adx-upload @done="closeUploadAndGetData" />
        </div>
      </div>
    </adx-modal>
    <adx-modal
      v-if="modalDelete"
      title="Delete Content"
      type="small"
      @modal-close="closeModalDelete"
    >
      <div slot="content" class="confirmation">
        <p class="confirmation__text regular-font">Are you sure want to delete this content?</p>
        <div class="confirmation__action">
          <button type="button" class="secondary btn-large" @click.stop="closeModalDelete()" :disabled="isDeleting">No</button>
          <button type="button" class="primary btn-large" :disabled="isDeleting">Yes</button>
        </div>
      </div>
    </adx-modal>
    <adx-modal
      v-if="modalPreview"
      type="full"
      @modal-close="closeModalPreview"
    >
      <div slot="content" class="media__preview">
        <div :class="['media__preview__content']">
          <slick
            ref="slick"
            :options="slickOptions"
            @beforeChange="handleBeforeChange"
            @init="handleInit">
            >
            <div class="item" v-for="(item, index) in filteredItems" :key="index">
              <div class="media__preview__content__slide">
                <div :class="['img-preview', previewOrientation]" :style="{backgroundImage: 'url(' + item.image + ')'}"></div>
              </div>
              <div class="media__preview__footer">
                <div class="filename-section">
                  <span class="section-key">Filename</span>
                  <span class="section-value">{{item.title}}</span>
                </div>
                <div class="filesize-section">
                  <span class="section-key">Filesize</span>
                  <span class="section-value">{{item.size}}</span>
                </div>
                <div class="created-section">
                  <span class="section-key">Last Added</span>
                  <span class="section-value">{{formatDate(item.last_updated)}}</span>
                </div>
              </div>
            </div>
          </slick>
        </div>
      </div>
    </adx-modal>
    <adx-fab :class="['media__fab', {page:!isModal}]" @clicked="openUpload()" />
    <div v-if="isLoading" class="media__loading">
      <adx-loading />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Slick from 'vue-slick'

import Dropdown from '@/components/Dropdown/ListDropdown'
import DropdownSort from '@/components/Form/SelectDropdown'
import Checkbox from '@/components/Form/Checkbox'
import Loading from '@/components/Loading/Primary'
import DetailSlider from '@/components/Slider/DetailSlider'
import Modal from '@/components/Modal'
import Upload from '@/views/Upload'
import FAB from '@/components/FAB'
import { sizeConverter } from '@/lib/util'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import { formatShortDate } from '@/lib/util'

export default {
  name: 'adx-other-media',
  components: {
    'adx-dropdown': Dropdown,
    'adx-dropdown-sort': DropdownSort,
    'adx-checkbox': Checkbox,
    'adx-loading': Loading,
    'adx-modal': Modal,
    'adx-detail-slider': DetailSlider,
    'adx-upload': Upload,
    'adx-fab': FAB,
    'slick': Slick
  },
  props: {
    type: {
      type: String,
      required: false,
      default: ''
    },
    orientation: {
      type: String,
      required: false,
      default: ''
    },
    display: {
      type: String,
      required: false,
      default: 'grid'
    },
    isModal: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      displayGrid: this.display == 'grid' ? true : false,
      selectAll: false,
      modalDelete: false,
      modalPreview: false,
      modalUpload: false,
      isLoading: false,
      isDeleting: false,
      searchingText: '',
      sortBy: 'latest',
      filterOrientation: this.orientation,
      listItem: [],
      listSelectedItem: [],
      listOrientation: [
        {
          'id': 1,
          'label': 'All orientation',
          'value': ''
        },
        {
          'id': 2,
          'label': 'Landscape',
          'value': 'Landscape'
        },
        {
          'id': 3,
          'label': 'Square',
          'value': 'Square'
        },
        {
          'id': 4,
          'label': 'Portrait',
          'value': 'Portrait'
        }
      ],
      listSort: [
        {
          'id': 1,
          'label': 'Last added',
          'value': 'latest'
        },
        {
          'id': 2,
          'label': 'First added',
          'value': 'earlier'
        },
        {
          'id': 3,
          'label': 'File size',
          'value': 'size'
        },
        {
          'id': 4,
          'label': 'File name',
          'value': 'name'
        },
      ],
      openModalItem: undefined,
      selectedPreview: null,
      previewOrientation: '',
      slickOptions: {
          slidesToShow: 1,
          nextArrow: '<button type="button" style="' +
                  'top:43%; width:32px; height:32px; display: flex; justify-content: center; align-items: center; position:absolute; right:-5px;"' +
                  'aria-disabled="false"><i class="icon-chevronright"></i></button>',
          prevArrow: '<button type="button" style="' +
                  'top:43%; width:32px; height:32px; display: flex; justify-content: center; align-items: center; position:absolute; left:-5px;"' +
                  'aria-disabled="false"><i class="icon-chevronleft"></i></button>',
          lazyLoad: 'progressive',
          responsive: [
            {
              breakpoint: 769,
              settings: {
                arrows: true,
                nextArrow: '<button type="button" style="' +
                  'top:25%; width:32px; height:32px; display: flex; justify-content: center; align-items: center; position:absolute; right:5px;"' +
                  'aria-disabled="false"><i class="icon-chevronright"></i></button>',
                prevArrow: '<button type="button" style="' +
                        'top:25%; width:32px; height:32px; display: flex; justify-content: center; align-items: center; position:absolute; left:5px;"' +
                        'aria-disabled="false"><i class="icon-chevronleft"></i></button>'
              }
            }
          ]
      },
    }
  },
  computed: {
    filteredItems() {
      let items = this.listItem
      if (this.listItem.length > 0) {

        if (this.filterOrientation != '') {
          items = items.filter((item) => {
            return item.orientation_display.toLowerCase() == this.filterOrientation
          })
        }

        if (this.searchingText != '') {
          let textLength = this.searchingText.length
          items = items.filter((item) => {
            return item.title.toLowerCase().substring(0, textLength) == this.searchingText
          })
        }

        if (this.sortBy != '') {
          switch(this.sortBy) {
            case 'earlier':
              items = items.sort((a, b) => {
                let firstDate = moment(a.created, "DD/MM/YYYY")
                let secondDate = moment(b.created, "DD/MM/YYYY")
                if (firstDate < secondDate) {
                  return -1
                }

                if (firstDate > secondDate) {
                  return 1
                }

                return 0
              })
              break;
            case 'name':
              items = items.sort((a, b) => {
                return a.title > b.title
              })
              break;
            case 'size':
              items = items.sort((a, b) => {
                return parseInt(a.size) - parseInt(b.size)
              })
              break;
            default:
              items = items.sort((a, b) => {
                let firstDate = formatShortDate(a.created)
                let secondDate = formatShortDate(b.created)
                if (firstDate > secondDate) {
                  return -1
                }

                if (firstDate < secondDate) {
                  return 1
                }

                return 0
              })
          }
        }
      }

      return items
    },
  },
  watch: {
    display(newValue, oldValue) {
      this.displayGrid = newValue == 'grid' ? true : false
    },
    orientation(newValue, oldValue) {
      this.filterOrientation = newValue
    },
    sortBy(newValue, oldValue) {
      this.sortBy = newValue
    },
  },
  beforeCreate() {

  },
  created() {
    this.getContents()
  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    getContents() {
      (async () => {
        this.isLoading = true
        this.listSelectedItem = []
        let response = await api.get(apiV2.collectionImage, {needToken: true})
        if (response.status == 200) {
          this.listItem = response.data
        }
        this.isLoading = false
      })();
    },
    // deleteContents() {
    //   (async () => {
    //     this.isDeleting = true
    //     let contents = this.listSelectedItem.join(',')
    //     let data = {
    //       'id': contents
    //     }
    //     let response = await api.put(apiV2.deleteContent, data, {needToken: true})
    //     this.isDeleting = false
    //     if (response.status == 200) {
    //       this.closeModalDelete()
    //       this.getContents()
    //     }
    //   })();
    // },
    changeView(display) {
      if (display == 'grid') {
        this.displayGrid = true
        return
      }

      this.displayGrid = false
    },
    focusSearch() {
      this.$refs.search.focus()
    },
    selectItem(id) {
      if (!this.listSelectedItem.includes(id)) {
        this.listSelectedItem.push(id)
      } else {
        let selectedIndex = this.listSelectedItem.indexOf(id);
        this.listSelectedItem.splice(selectedIndex, 1)
      }
    },
    selectAllItem() {
      this.listItem.forEach((item, index) => {
        if (!this.listSelectedItem.includes(item.id)) {
          this.listSelectedItem.push(item.id)
        }
      })
      this.selectAll = true
    },
    unselectAllItem() {
      this.listSelectedItem = []
      this.selectAll = false
    },
    selectOrientation(item) {
      let value = item.value || ''
      if (value.toLowerCase() == this.filterOrientation) {
        this.filterOrientation = ''
      } else {
        this.filterOrientation = value
      }
    },
    selectSortBy(item) {
      let value = item.value || ''
      if (value.toLowerCase() == this.sortBy) {
        this.sortBy = ''
      } else {
        this.sortBy = value
      }
    },
    toggleCheckAllItem() {
      if (this.selectAll) {
        this.unselectAllItem()
      } else {
        this.selectAllItem()
      }
    },
    openModalDelete() {
      this.modalDelete = true
    },
    closeModalDelete() {
      this.modalDelete = false
    },
    openModalPreview() {
      this.modalPreview = true
    },
    closeModalPreview() {
      this.modalPreview = false
    },
    openUpload() {
      this.modalUpload = true
    },
    closeUpload() {
      this.modalUpload = false
    },
    closeUploadAndGetData() {
      this.closeUpload()
      this.getContents()
    },
    assign(item) {
      this.$emit('selected', item)
    },
    preview(item, index) {
      this.openModalItem = index
      this.selectedPreview = item
      this.openModalPreview()
    },
    fileSizeConverter(size) {
      return sizeConverter(size);
    },
    listCollection(collections) {
      if (collections.length == 0) {
        return '-'
      }
      return collections.join(',')
    },
    getOrientationClass(rotation) {
      if (rotation == 0) {
        return 'landscape'
      } else {
        return 'portrait'
      }
    },
    handleBeforeChange(event, slick, currentSlide, nextSlide) {
      let nextItem = this.filteredItems[nextSlide]
      let currentItem = this.filteredItems[currentSlide]
      this.previewOrientation = nextItem.orientation_display.toLowerCase()
    },
    handleInit(event, slick) {
      slick.goTo(this.openModalItem, true)
    },
    formatDate(date) {
      return formatShortDate(date)
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang="scss">
.media {
  .modal .modal__content {
    overflow: auto;
    &__header {
      height: 64px;
      margin-bottom: 16px;
    }

    &.large {
      overflow: hidden;
    }
  }
}

.slick-list {
  max-height: 600px;
}
</style>
